import { render, staticRenderFns } from "./OldPageNewEntityBtn.vue?vue&type=template&id=41396f81&scoped=true&"
import script from "./OldPageNewEntityBtn.vue?vue&type=script&lang=js&"
export * from "./OldPageNewEntityBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41396f81",
  null
  
)

export default component.exports